import { isNullOrUndefined, findRule } from '../Utils';

const validate = (vObj) => {
  const { value } = vObj;
  const rule = findRule(vObj.errorBag, 'maxint');
  const max = parseInt(rule.ruleParams, 0);

  rule.feedback = `${vObj.fieldlabel} should be equal to or less than ${max}`;

  if (isNullOrUndefined(value)) {
    return max >= 0;
  }

  return parseInt(value, 10) <= max;
};

export { validate };

export default {
  validate,
};
